import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, MagArtSottoReminder, ModelNumStr, Reminder, ReminderGrPersone } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';
import { Observable } from 'rxjs';

@Injectable()
export class ReminderService extends CrudGenericsService<Reminder, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Reminder`);
    this.base = `${env.apiUrl}/api/Reminder/`;
  }

  // per magazzini-articoli sottoscorta
  GetReminder_MagArtSottoModel(): Observable<MagArtSottoReminder> {
    const u = `${this.base}GetReminder_MagArtSottoModel`;
    return this.http.get<MagArtSottoReminder>(u);
  }
  // per magazzini-articoli sottoscorta
  UpdReminder_MagArtSottoModel(model: MagArtSottoReminder): Observable<void> {
    const u = `${this.base}UpdReminder_MagArtSottoModel`;
    return this.http.post<void>(u, model);
  }
  // per magazzini-articoli sottoscorta
  GetReminder_RenderPersoneList(model: ReminderGrPersone[]): Observable<ModelNumStr[]> {
    const u = `${this.base}GetReminder_RenderPersoneList`;
    return this.http.post<ModelNumStr[]>(u, model);
  }
}
